import { render } from "./mxjerseyroster.vue?vue&type=template&id=8fba250e&scoped=true"
import script from "./mxjerseyroster.vue?vue&type=script&lang=js"
export * from "./mxjerseyroster.vue?vue&type=script&lang=js"

import "./mxjerseyroster.vue?vue&type=style&index=0&id=8fba250e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fba250e"]])

export default __exports__